import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { formatDate, publishedPosts, POSTS, isPublished } from "@/lib/blog";
import { SITE_URL } from "@/lib/site";

const TITLE = "Home Renovation Blog | Dog Day Renovations";
const DESC =
  "Practical planning guides for Winston-Salem homeowners from Dog Day Renovations — windows, bathrooms, and more.";

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/blog` },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/blog` }],
  }),
  component: BlogIndex,
});

function BlogIndex() {
  const live = publishedPosts();
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main className="mx-auto max-w-4xl px-4 py-14 sm:px-6">
        <h1 className="font-display text-4xl text-navy sm:text-5xl">Dog Day Renovations Blog</h1>
        <p className="mt-3 text-lg text-muted-foreground">Planning guides for Triad homeowners.</p>
        <ul className="mt-10 grid gap-6">
          {(live.length ? live : POSTS).map((p) => (
            <li key={p.slug} className="rounded-2xl border border-border bg-card p-6 shadow-sharp">
              <div className="text-xs font-bold uppercase tracking-widest text-primary-ink">
                {p.category} · {isPublished(p) ? formatDate(p.publishedAt) : `Coming ${formatDate(p.publishedAt)}`}
              </div>
              <h2 className="mt-2 text-2xl font-bold text-navy">
                <Link to="/blog/planning-bathroom-remodel-winston-salem" className="hover:text-primary-ink">
                  {p.title}
                </Link>
              </h2>
              <p className="mt-2 text-muted-foreground">{p.excerpt}</p>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
}
